/**
 * SORA Ambassador aff click tracking.
 * ?aff= → localStorage + cookie → Shopify cart attribute `aff`
 * so ORDERS_PAID note_attributes carry aff for commission audit.
 */
(function () {
  var STORAGE_KEY = "sora_aff";
  var COOKIE_DAYS = 30;
  var ATTR_KEY = "aff";

  function sanitize(raw) {
    return String(raw || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9-_]/g, "")
      .slice(0, 64);
  }

  function setCookie(name, value, days) {
    var maxAge = Math.floor(days * 86400);
    document.cookie =
      name +
      "=" +
      encodeURIComponent(value) +
      "; path=/; max-age=" +
      maxAge +
      "; SameSite=Lax";
  }

  function getCookie(name) {
    var parts = String(document.cookie || "").split(";");
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (p.indexOf(name + "=") === 0) {
        return decodeURIComponent(p.slice(name.length + 1));
      }
    }
    return "";
  }

  function readStored() {
    try {
      var ls = sanitize(localStorage.getItem(STORAGE_KEY) || "");
      if (ls) return ls;
    } catch (e) {}
    return sanitize(getCookie(STORAGE_KEY));
  }

  function persist(tag) {
    var clean = sanitize(tag);
    if (!clean) return "";
    try {
      localStorage.setItem(STORAGE_KEY, clean);
    } catch (e) {}
    setCookie(STORAGE_KEY, clean, COOKIE_DAYS);
    return clean;
  }

  function fromQuery() {
    try {
      var params = new URLSearchParams(window.location.search || "");
      return sanitize(params.get("aff") || params.get("affiliate") || "");
    } catch (e) {
      return "";
    }
  }

  function updateCartAttribute(tag) {
    if (!tag || !window.fetch) return;
    var routes =
      (window.Theme && Theme.routes) || {};
    var updateUrl =
      routes.cart_update_url ||
      "/cart/update.js";
    if (updateUrl.indexOf(".js") < 0 && updateUrl.indexOf("/cart/update") === 0) {
      updateUrl = "/cart/update.js";
    }
    var body = { attributes: {} };
    body.attributes[ATTR_KEY] = tag;
    fetch(updateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify(body),
    }).catch(function () {});
  }

  var fromUrl = fromQuery();
  var tag = fromUrl ? persist(fromUrl) : readStored();
  if (!tag) return;

  // Always re-attach on page load so new carts inherit the tag
  updateCartAttribute(tag);

  // Re-apply after common cart mutations (Horizon / theme events)
  document.addEventListener(
    "cart:update",
    function () {
      updateCartAttribute(tag);
    },
    { passive: true }
  );
  document.addEventListener(
    "cart:refresh",
    function () {
      updateCartAttribute(tag);
    },
    { passive: true }
  );
})();
